import React, { useCallback } from "react";
import { useObjectStore } from "../zustand/objects";
import { IconArrowForwardUp } from '@tabler/icons-react';
import EditorToolbarIcon from "./EditorToolbarIcon";
import { CHROME_TOOLBAR_ICON_GLYPH } from "../utils/editorChromeTheme";

const RedoButton = ({ redoActions, iconColour, inGroup = false }) => {
  const {
    redoActions: storeRedoActions,
    arrangeUndoRedo,
    sendUpdateToChannel
  } = useObjectStore();

  const actionsToUse = Array.isArray(redoActions) ? redoActions : storeRedoActions;

  const handleRedoClick = useCallback(() => {
    const data = actionsToUse[0]
    arrangeUndoRedo(data).then(() =>
      sendUpdateToChannel(data))
  }, [actionsToUse, arrangeUndoRedo, sendUpdateToChannel])

  return (
    <EditorToolbarIcon
      label="Redo"
      disabled={actionsToUse.length <= 0}
      onClick={handleRedoClick}
      iconColour={iconColour}
      inGroup={inGroup}
    >
      <IconArrowForwardUp size={CHROME_TOOLBAR_ICON_GLYPH} />
    </EditorToolbarIcon>
  );
};

export default RedoButton;
